import {
	ArrayMaxSize,
	ArrayNotEmpty,
	IsArray,
	IsObject,
	IsOptional,
	IsString,
	MaxLength,
	ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

// One BI event in the batch. Mirrors the shape of the bi_events table.
// `event_type` is the snake_case name from the WCC BI Events doc
// (e.g. `auth_completed`, `marketing_site_viewed`, `forecast_batch_submitted`).
// The server stamps `occurred_at` so the client can't backfill — anti-abuse.
export class TrackBiEventDto {
	@IsString()
	@MaxLength(80)
	event_type: string;

	@IsOptional()
	@IsString()
	@MaxLength(64)
	session_id?: string;

	@IsOptional()
	@IsString()
	@MaxLength(32)
	client_platform?: string;

	@IsOptional()
	@IsString()
	@MaxLength(80)
	utm_source?: string;

	@IsOptional()
	@IsString()
	@MaxLength(80)
	utm_medium?: string;

	@IsOptional()
	@IsString()
	@MaxLength(120)
	utm_campaign?: string;

	@IsOptional()
	@IsString()
	@MaxLength(120)
	utm_content?: string;

	@IsOptional()
	@IsObject()
	properties?: object;
}

// Batched payload — the frontend track() helper buffers events and flushes
// in groups to amortize the request overhead. Hard cap of 50 events per
// batch (the rate-limiter guards the per-session frequency separately).
export class TrackBiEventsBatchDto {
	@IsArray()
	@ArrayNotEmpty()
	@ArrayMaxSize(50)
	@ValidateNested({ each: true })
	@Type(() => TrackBiEventDto)
	events: TrackBiEventDto[];
}

export interface TrackBiEventsResponse {
	accepted: number;
}
